import React from 'react';
import { Switch, Route } from 'react-router';
import { useSelector } from 'react-redux';
import CurrentUserEdit from './CurrentUserEdit';
import ProfileTopTabs from '../ProfileTopTabs';
import { Permission } from '../../../components';
import { is, or, roles } from '../../../utility/guard';
import CurrentUserNotifications from './CurrentUserNotifications';
import { selectCurrentUser } from '../../../store/modules/users/selectors';

const ProfileTab = () => {
  const user = useSelector(selectCurrentUser);

  return (
    <>
      <ProfileTopTabs loading={user.loading} tabResource="profileUser" />
      <Switch>
        <Route path="/dashboard/profile/me">
          <CurrentUserEdit />
        </Route>
        <Route path="/dashboard/profile/admin">
          <Permission guard={or(is(roles.admin), is(roles.superAdmin))}>
            <CurrentUserEdit showOnlyAdminSettings />
          </Permission>
        </Route>
        <Route path="/dashboard/profile/notifications">
          <CurrentUserNotifications />
        </Route>
      </Switch>
    </>
  );
}

export default ProfileTab;
